module.exports = __webpack_public_path__ + "img/partners.5cf65fa7.png";